/**
 * Хелперы сборки опций для <Select>.
 *
 * Здесь два варианта источника опций:
 *   - статическая карта-константа (PRIORITIES, PROJECT_STATUSES, ...);
 *   - динамический список из реквизита/стора (проекты, сотрудники, отделы).
 *
 * Оба всегда начинаются с пункта «все» (allLabel): в фильтрах проекта
 * пустой выбор читается как «все», никогда как «ничего не выбрано».
 * Это правило живёт здесь - если решим поменять его (например, убрать
 * пункт «все» для какого-то фильтра), менять придётся только в одном месте.
 *
 * Сортировка опций - не здесь, а в самом Select (см. sortOptions ниже).
 * Так правило одно на весь проект: вызывающий код порядок не задаёт,
 * а Select применяет его к любому источнику опций.
 *
 * Стабильные мапперы (toXxxOption) внизу файла: используются с
 * useFilterOptions. Модульные константы, а не inline-стрелки - иначе
 * useMemo внутри useFilterOptions будет пересчитывать опции каждый
 * рендер (у inline-стрелки новая идентичность при каждом вызове).
 */

const PINNED_VALUES = new Set(["", "all", "any", "none"]);

export const optionsFromMap = (
  map,
  allLabel,
  labelOf = (v) => v.label || v,
) => [
  { value: "all", label: allLabel },
  ...Object.entries(map).map(([k, v]) => ({ value: k, label: labelOf(v) })),
];

export const optionsFromList = (list, allLabel, toOption) => [
  { value: "all", label: allLabel },
  ...list.map(toOption),
];

export const sortOptions = (options) => {
  if (!Array.isArray(options) || options.length < 2) return options || [];
  const pinned = [];
  const sortable = [];
  for (const opt of options) {
    if (PINNED_VALUES.has(String(opt.value))) pinned.push(opt);
    else sortable.push(opt);
  }
  sortable.sort((a, b) => String(a.label).localeCompare(String(b.label), "ru"));
  return [...pinned, ...sortable];
};

// ─── Стабильные мапперы для useFilterOptions ─────────────────────────────

export const toProjectOption = (p) => ({ value: p.id, label: p.code });
export const toEmployeeOption = (e) => ({
  value: e.id,
  label: `${e.last} ${e.first}`,
});
export const toEmployeeShortOption = (e) => ({ value: e.id, label: e.last });
export const toDeptOption = (d) => ({ value: d.id, label: d.name });
export const toIdNameOption = (item) => ({ value: item.id, label: item.name });
export const toStatusEntryOption = ([key, val]) => ({
  value: key,
  label: val.label,
});
